exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pageIcons {\n  padding-bottom: 2.5rem;\n  padding-bottom: 6.25vw; }\n  .pageIcons h4 {\n    background: #eee;\n    padding: 0.3125rem 0.625rem;\n    padding: 0.78125vw 1.5625vw; }\n  .pageIcons ul {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-gap: 0.625rem;\n    grid-gap: 1.5625vw;\n    text-align: center; }\n    .pageIcons ul li {\n      border: 1px dashed #ccc;\n      height: 2.5rem;\n      height: 6.25vw;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n          align-items: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n    .pageIcons ul p {\n      display: none; }\n\n.table {\n  border: 1px solid #ccc;\n  width: 100%; }\n  .table td,\n  .table th {\n    border: 1px solid #ccc;\n    padding: 0.3125rem;\n    padding: 0.78125vw; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./node_modules/sass-loader/lib/loader.js!./src/components/Icons/Icons.scss
// module id = 295
// module chunks = 0